import { Grid } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import { WhatSkillContent } from 'src/types/components/shared/atom'
import Card from './card/Card'
import useStyles from './Style'
import rehypeSlug from 'rehype-slug'
import ReactMarkdown from 'react-markdown'
import { useRouter } from 'next/router'
import { ButtonComponent } from 'src/components/shared/atoms'
import rehypeRaw from 'rehype-raw'

interface IProps {
  zenMode: boolean
  content: WhatSkillContent
}
const WhatSkill: React.FC<IProps> = ({ zenMode, content }) => {
  const { heading, text, cardData, button } = content
  const { classes } = useStyles()
  const router = useRouter()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const rehypeRawDec:any = rehypeRaw;
  return (
    <Grid
      className={clsx(
        classes.rootContainer,
        zenMode && classes.zenRootContainer
      )}
    >
      <Grid className={classes.textContainer}>
        <Grid className={classes.heading}>{heading}</Grid>
        <Grid className={classes.text}>
          {' '}
          <ReactMarkdown rehypePlugins={[rehypeRawDec,rehypeSlug]}>{text}</ReactMarkdown>
        </Grid>
      </Grid>
      <Grid container sx={{ maxWidth: '1280px', margin: 'auto' }}>
        {cardData && cardData.length
          ? cardData.map((curr, index) => (
              <Grid
                alignSelf="stretch"
                key={index}
                item
                md={3}
                sm={4}
                xs={6}
                my={8}
              >
                <Grid sx={{ padding: '10px' }}>
                  <Card zenMode={zenMode} content={curr} />
                </Grid>
              </Grid>
            ))
          : ''}
      </Grid>
      {router.pathname === '/fundraise' && button && (
        <ButtonComponent
          type="text"
          text={button.content}
          className={classes.btn}
          gradient
          wrapperClass={classes.btnWrapper}
          onClick={() => {
            button.href ? router.push(button.href) : ''
          }}
        />
      )}
    </Grid>
  )
}

export default WhatSkill
